import { $ } from "../../../../../../common/scripts/Libs";

class SSCV2Nav {

    constructor() {
        this.nav = $('#CSV2-nav');
        this.toggle = $('#CSV2-btn');
        this.links
        this.isOpen = false;
    }
    close() {
        if (!this.isOpen) { return false }
        this.isOpen = false
        this.nav.removeClass('isOpen')
    }

    open() {
        if (this.isOpen) { return false }
        this.isOpen = true
        this.nav.addClass('isOpen')
    }

    getLinks() {
        this.links = $('[data-linkCSV2]');

        if (this.links.length > 0) {
            this.nav.removeClass('d-none')
        }
    }

    renderLists() {
        this.getLinks();

        const ob = this;
        const list = $('#CSV2-nav ul');

        this.links.each(function (index, value) {

            const link = $(`<li>${value.dataset.linkcsv2}</li>`).on('click', (el) => {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(this).offset().top - 150,
                    behavior: 'smooth'
                }, 200);
                ob.close()
            });

            list.append(link)

        })

    }

    init() {
        this.renderLists();

        this.toggle.on("click", () => {
            if (!this.isOpen) {
                this.open()
            } else {
                this.close()
            }
        })
    }

}

export default SSCV2Nav;